import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TransitCreateData, TransitListItem } from '@e-origin/contracts';
import { Transit } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface CreateTransitProps {
  transit: Partial<Transit>;
}

export const useCreateTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transit }: CreateTransitProps): Promise<TransitListItem> => {
      const { name, customer, template, MRN, group } = transit as unknown as TransitCreateData;

      const result = await apiClient.transit.createTransit.mutation({ body: { name, customer, template, MRN, group } });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success(`New transit was uploaded!`);
    },
    onError: (error) => {
      const originalError = (error as any).response?.data?.originalError;
      showErrorToast(error, originalError || `Error uploading the transit!`);
    },
  });
};
